export default __webpack_public_path__ + "static/media/twilloOTPIcon.7866f77d.png";